// JavaScript code for acf_blocks/anchor-link-bar component
(($) => {

     "use strict";
     if (!$('.acf-blocks-anchor-link-bar').length) {
         return
     }
     console.log("acf_blocks/anchor-link-bar scripts loaded...");

    $('.acf-blocks-anchor-link-bar').on('click', 'a', function(e) {
        e.preventDefault();
        let id = $(this).attr('href');
        let offset = $(id).offset().top - 180;
        $('html, body').scrollTop(offset);
    });

})(jQuery);